<template>
  <div>

    <!-- Affichage des descriptifs des plans -->
    <div v-if="planTransactionData.transactionStatusCode === '050' & flagShowPlanList" class="block">
 
      <div  class="col-sm-12 push">
        <h3 class="align-center push">{{subscriptionOptionDescription01[actualLanguage]}}</h3>
        <h5 class="align-center push">{{subscriptionOptionDescription02[actualLanguage]}}</h5>
        <h5 class="align-center push">{{subscriptionOptionDescription03[actualLanguage]}}</h5>
        <h5 class="align-center push">{{subscriptionOptionDescription04[actualLanguage]}}</h5>
        <h5 class="align-center push">{{subscriptionOptionDescription05[actualLanguage]}}</h5>
        <h5 class="align-center push">{{subscriptionOptionDescription06[actualLanguage]}}</h5>
        <h5 class="align-center push">{{subscriptionOptionDescription07[actualLanguage]}}</h5>
      </div>

      <div  class="col-sm-12">
        <h2 class="align-center">{{labelPaymentToggle[actualLanguage]}}</h2>
      </div>
      <!-- Affichage du bouton de sélection Mensuel/Annuel
      <div  class="col-sm-12">
        <div v-if = "displayYearToggleSelect" class="col-xs-12 align-center">
            <label class="css-input switch switch-lg switch-success">
                <span class="h4">{{labelPaymentToggleMonth[actualLanguage]}} </span><input type="checkbox" checked v-model="monthYearPaymentToggle"><span></span><span class="h4">{{labelPaymentToggleYear[actualLanguage]}}</span> 
            </label>
        </div>
      </div>
      -->

      <div class="bg-white">
      <section class="content content-boxed overflow-hidden">
      <div class="row push-20-t push-20">

      <div v-for="(planLine, index) in planDescription" :key="index" class="col-sm-12 col-lg-12 push">
          <!-- Startup Plan -->

          <div v-if= "planLine['DisplayPlan'][monthYearPaymentToggle]">
          <a class="block block-bordered block-link-hover3 text-center" href="javascript:void(0)">
              <div class="block-header">
                  <h3 class="block-title">{{planLine['Title'][actualLanguage]}}</h3>
              </div>
              <div class="block-content block-content-full bg-gray-lighter">
                  <div class="h1 font-w700 push-10">${{planLine['PlanPricing'][monthYearPaymentToggle]}}</div>
                  <div v-if= "planLine['DisplayButton'][monthYearPaymentToggle]">
                    
                    <div v-if = "monthYearPaymentToggle" class="h5 font-w300 text-muted">{{labelPriceYearly[actualLanguage]}}</div>
                    <div v-else class="h5 font-w300 text-muted">{{labelPriceMonthly[actualLanguage]}}</div>
                  </div>

              </div>
              <div class="block-content">
                  <table class="table table-borderless table-condensed">
                      <tbody>
                          <tr v-for= "descrip in planLine['Description']">
                            <td>{{descrip['text1'][actualLanguage]}} <strong>{{descrip['text2'][actualLanguage]}}</strong> {{descrip['text3'][actualLanguage]}}</td>
                          </tr>
                      </tbody>
                  </table>
              </div>

              <div  class="block-content">

                  <div v-for="(option, index2) in planLine.options" :key="index" class="col-sm-12 push">

                      <div v-if="option.valueType=='BOOL'" class="col-xs-12 col-md-12">

                        <div class="col-xs-12 col-sm-12">
                            <h5>Option : {{option.title[actualLanguage]}}</h5>
                            <p>{{option.description[actualLanguage]}}</p>
                            <h5>{{option.priceDescription[actualLanguage]}} : {{option.unitPrice}} $</h5>

                        </div>
                        <div class="col-xs-12 col-sm-12">{{optionSelectLabel[actualLanguage]}}
                            <label class="css-input switch switch-success">
                            <input type="checkbox" checked v-model="option.flagOptionEnabled">
                            <span></span>
                            </label>
                        </div>

                      </div>

                  </div>
              </div>
              

              <div v-if= "planLine['DisplayButton'][monthYearPaymentToggle]" class="block-content block-content-mini block-content-full bg-gray-lighter">

                  <!--
                  //RETRAIT STRIPE

                  <span class="btn btn-default">
                    <button v-on:click="selectPlan(index)" class="btn btn-success" type="button"><i  class="fa fa-arrow-up push-5-r"></i>{{labelBtnSignUp[actualLanguage]}}</button>
                  </span>
                  -->
                  <h3>{{contactEVSensForSubscribe[actualLanguage]}}</h3>
              </div>
          </a>
          </div>
          <!-- END Startup Plan -->
      </div>

      </div>
      </section>
      </div>

<!--
<button v-on:click="selectPlan(planLine['PlanID'])" class="btn btn-success" type="button"><i  class="fa fa-arrow-up push-5-r"></i>{{labelBtnSignUp[actualLanguage]}}</button>

-->

    </div>
       <!-- FIN : Affichage des descriptifs des plans -->




    <!-- ===================================================================-->
    <!-- ===================================================================-->
    <!-- Confirmation du plan choisi -->
    <!-- ===================================================================-->
    <!-- ===================================================================-->
      <div v-if="planTransactionData.transactionStatusCode === '060'" class="row">
        <div class="row">
            <h2 class="font-w200 text-center">{{SelectPlanText01[actualLanguage]}} {{planTransactionData.planName}}</h2>          
        </div>

        <div v-if= "monthYearPaymentToggle" class="row">
          <!-- <h4 class="font-w200 text-center">{{SelectPlanText02[actualLanguage]}} {{planTransactionData.renewalPrice}} $</h4> -->
          <h4 class="font-w200 text-center">{{SelectPlanText02[actualLanguage]}} {{sousTotal1}} $</h4>
        </div>
        <div v-else class="row">
          <!-- <h4 class="font-w200 text-center">{{SelectPlanText03[actualLanguage]}} {{planTransactionData.renewalPrice}} $</h4> -->
          <h4 class="font-w200 text-center">{{SelectPlanText03[actualLanguage]}} {{sousTotal1}} $</h4>
        </div>

        <div v-if="planTransactionData.firstPaymentRebate > 0" class="row align-center">
          <hr size="50">
          <h4 class="font-w200 text-center">{{SelectPlanText04[actualLanguage]}} {{planTransactionData.firstPaymentRebate}} {{SelectPlanText05[actualLanguage]}}
          </h4>
          <hr size="50">
        </div>
        

        <!-- Suite a un choix de l'utilisateur, affichage du bandeau du choix fait -->
        <div v-if="planTransactionData.transactionStatusCode === '060'" class="block">
          <div class="col-xs-12">
            <div class="row align-center">
              <hr size="50">
              <h4 class="font-w200 text-center">{{SelectPlanText06[actualLanguage]}}</h4>
              <label class="css-input switch switch-success">{{SelectPlanText08[actualLanguage]}}
                  <input type="checkbox" checked v-model="planTransactionData.automaticRenewFlag"><span></span>{{SelectPlanText07[actualLanguage]}}
              </label>
              <hr size="50">

              <div v-if="planTransactionData.automaticRenewFlag">
                <h4  class="font-w200 text-center">{{SelectPlanText09A[actualLanguage]}}</h4>
                <h5  class="font-w200 text-center">{{SelectPlanText09B[actualLanguage]}}</h5>
                <hr size="50">
                <h6  class="font-w200 text-center">{{SelectPlanText09C[actualLanguage]}}</h6>
                <h6  class="font-w200 text-center">{{SelectPlanText09D[actualLanguage]}}</h6>
                <h6  class="font-w200 text-center">{{SelectPlanText09E[actualLanguage]}}</h6>
              </div>
              
              <div v-else>
                <h4  class="font-w200 text-center">{{SelectPlanText10A[actualLanguage]}}</h4>
                <hr size="50">
                <h6  class="font-w200 text-center">{{SelectPlanText10B[actualLanguage]}}</h6>
                <h6  class="font-w200 text-center">{{SelectPlanText10C[actualLanguage]}}</h6>
                <h6  class="font-w200 text-center">{{SelectPlanText10D[actualLanguage]}}</h6>
              </div>
              <hr size="50">
            </div>

            <div class="row align-center">
              <div class="col-sm-12">
                <div class="block block-transparent">
                    <div class="block-header"> 
                        <h3 class="block-title text-center" >{{SelectPlanText11[actualLanguage]}}</h3>
                    </div>
                    <div class="block-content">
                        <p>{{politiqueAchatPlan[actualLanguage]}}</p>
                    </div>
                </div>
              </div>
            </div>

            <div class="row align-center push">
              <label class="css-input switch switch-success">
                  <input type="checkbox" checked v-model="acceptConditionFlag"><span></span>{{SelectPlanText12[actualLanguage]}}
              </label>
            </div>

            <div class="row push">
              <h3 class="block-title text-center" >{{validateLocalisation[actualLanguage]}}</h3>
              <div class="col-xs-12 col-md-6">
                    <div class="form-group">
                      <label class="col-xs-12" for="example-select">{{ selectMyCountry[actualLanguage] }}</label>
                      <div class="col-sm-12">
                          <select class="form-control" @click="selectActualCountry()" v-model=actualCountryIndex  size="1">
                              <option v-for="(country,countryIndex) in countryStateTaxRates" :value="countryIndex">{{country.StateTaxData.CountryName[actualLanguage]}}</option>
                          </select>
                      </div>
                  </div>
              </div>
              <div v-if="actualCountryIndex >= 0" class="col-xs-12 col-md-6">
                    <div class="form-group">
                      <label class="col-xs-12" for="example-select">{{ selectMyState[actualLanguage] }}</label>
                      <div class="col-sm-12">
                          <select class="form-control" @click="selectActualState()" v-model=actualStateIndex  size="1">
                              <option v-for="(state,stateIndex) in countryStateTaxRates[actualCountryIndex].StateTaxData.StateList" :value="stateIndex">{{state.Name[actualLanguage]}}</option>
                          </select>
                      </div>
                  </div>
              </div>
            </div>


            <hr size="50">

          </div>
        </div>

        <hr size="50">





        <!-- Affichage des boutons pour effectuer la transaction -->
        <div v-if="planTransactionData.transactionStatusCode === '060'"  class="row">
          
            <div class="col-xs-6">
              <p><button @click="cancelSelection()" type="button" class="btn btn-danger align-right" name="button">{{ButtonCancelSelection[actualLanguage]}}</button></p>
            </div>
            <div  v-if= "acceptConditionFlag" class="col-xs-6">
              <p><button @click="confirmOrder()" type="button" class="btn btn-success align-left" name="button">{{ButtonProceedOrder[actualLanguage]}}</button></p>
            </div>
          
        </div>
      </div>
 


    <!-- ===================================================================-->
    <!-- ===================================================================-->
    <!-- Description de la facture du premier payment-->
    <!-- ===================================================================-->
    <!-- ===================================================================-->
    <div v-if="planTransactionData.transactionStatusCode === '100'"  class="row">

      <div v-if= "planTransactionData.firstPaymentRebate > 0"  class="row">
          <h3 class="block-title text-center" >{{InvoiceHeaderFirst[actualLanguage]}}</h3>
      </div>
      <div v-else  class="row">
          <h3 class="block-title text-center" >{{InvoiceHeader[actualLanguage]}}</h3>
      </div>


      <div class="table-responsive push-50">
          <table class="table table-bordered table-hover">
              <thead>
                  <tr>
                      <th class="text-center" style="width: 50px;"></th>
                      <th>Produit</th>
                      <th class="text-center" style="width: 100px;">{{InvoiceQuantity[actualLanguage]}}</th>
                      <th class="text-right" style="width: 120px;">{{InvoiceUnitPrice[actualLanguage]}}</th>
                      <th class="text-right" style="width: 120px;">{{InvoicePrice[actualLanguage]}}</th>
                  </tr>
              </thead>
              <tbody>
                  <tr>
                      <td class="text-center">1</td>
                      <td>
                          <p class="font-w600 push-10">{{InvoiceEVSensServicePlan[actualLanguage]}} {{planTransactionData.planName}}</p>
                          <div class="text-muted">{{titlePlanTable[actualLanguage][monthYearPaymentToggle]}}</div>
                      </td>
                      <td class="text-center"><span class="badge badge-primary">1</span></td>
                      <td class="text-right">$ {{this.planTransactionData.renewalPrice}}</td>
                      <td class="text-right">$ {{this.planTransactionData.renewalPrice}}</td>
                  </tr>

                  <tr v-for="(option, index3) in this.planTransactionData.options">
                      <td class="text-center">{{index3+2}}</td>
                      <td>
                          <p class="font-w600 push-10">{{option.billingDescription[actualLanguage]}}</p>
                      </td>
                      <td v-if="option.flagOptionEnabled" class="text-center"><span class="badge badge-primary">{{option.quantity}}</span></td>
                      <td v-else class="text-right">0</td>
                      <td class="text-right">$ {{option.unitPrice}}</td>

                      <td v-if="option.flagOptionEnabled" class="text-right">$ {{option.unitPrice}}</td>
                      <td v-else class="text-right">0</td>
                  </tr>


                  <tr v-if = "planTransactionData.firstPaymentRebate > 0">
                      <td class="text-center">2</td>
                      <td>
                          <p class="font-w600 push-10">{{InvoiceSubscriptionCredit[actualLanguage]}}</p>
                      </td>
                      <td class="text-center"><span class="badge badge-primary">1</span></td>
                      <td class="text-right">$ -{{this.planTransactionData.firstPaymentRebate}}</td>
                      <td class="text-right">$ -{{this.planTransactionData.firstPaymentRebate}}</td>
                  </tr>

                  <tr>
                      <td colspan="4" class="font-w600 text-right">{{InvoiceSubTotal[actualLanguage]}}</td>
                      <td class="text-right">$ {{sousTotal1}}</td>
                  </tr>

                  <tr v-for="(taxLine, index2) in actualTaxes01">
                      <td colspan="4" class="font-w600 text-right">{{taxLine.Label[actualLanguage]}}</td>
                      <td class="text-right">$ {{taxLine.Amount}}</td>
                  </tr>

                  <tr class="active">
                      <td colspan="4" class="font-w700 text-uppercase text-right">Total</td>
                      <td class="font-w700 text-right">$ {{total1}}</td>
                  </tr>
              </tbody>
          </table>
      </div>
      <!-- END Description de la facture -->




    <!-- Description de la facture des autres paiement-->

      <div v-if= "planTransactionData.firstPaymentRebate > 0"  class="row">
          <h3 class="block-title text-center" >{{InvoiceHeaderNext[actualLanguage]}}</h3>
      </div>


      <div v-if= "planTransactionData.firstPaymentRebate > 0" class="table-responsive push-50">
          <table class="table table-bordered table-hover">
              <thead>
                  <tr>
                      <th class="text-center" style="width: 50px;"></th>
                      <th>Produit</th>
                      <th class="text-center" style="width: 100px;">{{InvoiceQuantity[actualLanguage]}}</th>
                      <th class="text-right" style="width: 120px;">{{InvoiceUnitPrice[actualLanguage]}}</th>
                      <th class="text-right" style="width: 120px;">{{InvoicePrice[actualLanguage]}}</th>
                  </tr>
              </thead>
              <tbody>
                  <tr>
                      <td class="text-center">1</td>
                      <td>
                          <p class="font-w600 push-10">{{InvoiceEVSensServicePlan[actualLanguage]}} {{planTransactionData.planName}}</p>
                          <div class="text-muted">{{titlePlanTable[actualLanguage][monthYearPaymentToggle]}}</div>
                      </td>
                      <td class="text-center"><span class="badge badge-primary">1</span></td>
                      <td class="text-right">$ {{this.planTransactionData.renewalPrice}}</td>
                      <td class="text-right">$ {{this.planTransactionData.renewalPrice}}</td>
                  </tr>

                  <tr v-for="(option, index3) in this.planTransactionData.options">
                      <td class="text-center">{{index3+2}}</td>
                      <td>
                          <p class="font-w600 push-10">{{option.billingDescription[actualLanguage]}}</p>
                      </td>
                      <td v-if="option.flagOptionEnabled" class="text-center"><span class="badge badge-primary">{{option.quantity}}</span></td>
                      <td v-else class="text-right">0</td>
                      <td class="text-right">$ {{option.unitPrice}}</td>

                      <td v-if="option.flagOptionEnabled" class="text-right">$ {{option.unitPrice}}</td>
                      <td v-else class="text-right">0</td>
                  </tr>

                  <tr>
                      <td colspan="4" class="font-w600 text-right">{{InvoiceSubTotal[actualLanguage]}}</td>
                      <td class="text-right">$ {{sousTotal2}}</td>
                  </tr>

                  <tr v-for="(taxLine, index3) in actualTaxes02">
                      <td colspan="4" class="font-w600 text-right">{{taxLine.Label[actualLanguage]}}</td>
                      <td class="text-right">$ {{taxLine.Amount}}</td>
                  </tr>
                  <tr class="active">
                      <td colspan="4" class="font-w700 text-uppercase text-right">Total</td>
                      <td class="font-w700 text-right">$ {{total2}}</td>
                  </tr>

              </tbody>
          </table>
      </div>
      <!-- END Description de la facture -->



      <div class="col-xs-6">
        <p><button @click="cancelSelection()" type="button" class="btn btn-danger align-right" name="button">{{ButtonCancelSelection[actualLanguage]}}</button></p>
      </div>

      <div  class="col-xs-6">
        <p><button @click="showModal('stripe-paiement')" type="button" class="btn btn-success align-left" name="button">{{ButtonProceedPayment[actualLanguage]}}</button></p>
      </div>

    </div>
    <!-- END Table -->



  </div>
</template>

<script>

import _ from 'underscore'
import { mapState, mapActions } from 'vuex'
import userPlanDescriptions from '@/views/profile/UserPlanDescriptions.js'
import StripePaiement from './StripePaiment'


export default {
  props: ['portData'],

  components: {
    StripePaiement
  },


  data() {
    return {
      displayDataTable : false,
      monthYearPaymentToggle : true,
      displayYearToggleSelect : true,
      
      displaySelectedPlanFlag:false,
      acceptConditionFlag:false,
      flagShowPlanList : false,

      countryStateTaxRates : [],
      actualTaxes01:[],
      actualTaxes02:[],
      selectMyCountry: {FR: 'Pays:', EN: 'Country'},
      selectMyState: {FR: 'Province:', EN: 'State'},
      actualCountryIndex : -1,
      actualCountryName : 'ND',
      actualStateNames : {EN:'ND',FR:'ND'},
      actualStateIndex : -1,

      actualLanguage : "FR",
      labelTableTop: {FR: 'Afficher le tableau des données', EN: 'Display data table'},
      subscriptionOptionDescription01: {FR: "Les abonnements vous permettent d'accéder aux services suivants:",
                                         EN: 'Subscriptions allow you to access the following services:'},

      subscriptionOptionDescription02: {FR: "Plus longue durée d'historique de données disponible.",
                                         EN: 'Longest data history available.'},
      subscriptionOptionDescription03: {FR: "Service de surveillance (alertes liées aux appareils mesurés).",
                                         EN: 'Monitoring service (alerts related to measured devices).'},
      subscriptionOptionDescription04: {FR: "Enregistrement de l'historique de données météorologique.",
                                         EN: 'Record weather data history.'},
      subscriptionOptionDescription05: {FR: "Prolongement de votre garantie de matériel.",
                                         EN: 'Extending Your Hardware Warranty.'},
       subscriptionOptionDescription06: {FR: "Capacité d'enregistrer plus de module de mesure a votre profil.",
                                         EN: 'The ability to record more measuring modules to your profile.'}, 
       subscriptionOptionDescription07: {FR: "Possibilité de créer plus d'appareils mesurés dans votre profil.",
                                         EN: 'The possibility to create more measured devices in your profile'},                                                                                
      labelPaymentToggle: {FR: "Abonnements disponibles:", EN: 'Subscription available:'},



      labelPaymentToggleYear: {FR: 'Facturé annuellement', EN: 'Annually billed'},
      labelPaymentToggleMonth: {FR: 'Facturé mensuellement', EN: 'Monthly billed'},
      labelPriceMonthly: {FR: 'Par mois', EN: 'per month'},
      labelPriceYearly: {FR: 'Par année', EN: 'Per year'},

      titlePlanTable: {FR:{false: 'Facturé mensuellement', true: 'Facturé annuellement'},EN:{false: 'Monthly billed', true: 'Annually billed'}},

      labelBtnSignUpFree: {FR: "Gratuit", EN: 'Free'},
      labelBtnSignUp: {FR: "S'inscrire", EN: 'Sign up'},
      contactEVSensForSubscribe: {FR: "Pour vous abonnez à ce forfait, contactez support@evsens.ca pour recevoir un code de plan pré-enregistré.",
                                   EN: 'To subscribe to this plan, contact support@evsens.ca to receive a pre-registered plan code.'},

      alertSubscriptionLimitation01: {FR: 'Votre abonnement ne peut pas être remboursé automatiquement, contactez support@evsens.ca', EN: 'Your subscription cannot be refund automatically, contact support@evsens.ca'},

      optionSelectLabel : {FR: "Ajouter cette option", EN: 'Add this option'},

      planDescription : userPlanDescriptions,

      SelectPlanText01: {FR: 'Plan sélectionné :', EN: 'Selected plan :'},
      SelectPlanText02: {FR: 'Paiement annuel de :', EN: 'Yearly payment of :'},
      SelectPlanText03: {FR: 'Paiement mensuel de :', EN: 'Monthly payment of :'},
      SelectPlanText04: {FR: 'Un rabais de :', EN: 'Credit of :'},
      SelectPlanText05: {FR: '$ sera appliqué à votre premier paiement due au crédit de votre plan actuel.', EN: '$ will be applied on your first payment for your precedent subscription'},
      SelectPlanText06: {FR: 'Renouvellement automatique', EN: 'Automatic renewal'},
      SelectPlanText07: {FR: 'Activé', EN: 'Activated'},
      SelectPlanText08: {FR: 'Désactivé', EN: 'Unactivated'},

      SelectPlanText09A: {FR: "Ceci vous permet de fixer le prix de votre forfait d'abonnement.", EN: 'This allows you to set the price of your subscription package.'},
      SelectPlanText09B: {FR: "Il vous est possible de vous désinscrire du renouvellement automatique en tout temps.", EN: 'You can unsubscribe from automatic renewal at any time.'},
      SelectPlanText09C: {FR: 'En date du renouvellement, votre carte de crédit sera débitée automatiquement.', EN: 'On the renewal date, your credit card will be charged automatically.'},
      SelectPlanText09D: {FR: "Notez que si la date d'expiration de votre carte est antérieur à la date de renouvellement du plan,", EN: 'Please note that if your card expires before the plan renewal date,'},
      SelectPlanText09E: {FR: "un courriel vous sera transmit pour vous aviser d'enregistrer vos nouvelles données de carte de crédit.", EN: 'an email will be sent to you advising that you need to save new credit card in your profile.'},

      SelectPlanText10A: {FR: "Avant la fin de votre période d'abonnement, vous devez soit sélectionner l'option Renouvellement Automatique pour prolonger votre service ou vous abonner à un plan disponible en cette date*.", EN: 'Before the end of your subscription period, you must either select the Automatic Renewal option to extend your service or subscribe to a plan available on this date *.'},
      SelectPlanText10B: {FR: "Trois jours avant la fin de votre plan, un avis par courriel vous sera transmit.", EN: 'Three days before the end of your plan, an email notification will be sent to you.'},
      SelectPlanText10C: {FR: "Si aucune action n'est prise, vos accèes seront automatiquement mis au service de base à la date de fin de votre abonnement.", EN: 'If no action is taken, your access will automatically be put to the basic service on the end date of your subscription.'},
      SelectPlanText10D: {FR: "*La disponibilité des plans peut varier, un renouvellement automatique permet de préserver les option et le prix d'un plan.", EN: '* The availability of the plans can vary, an automatic renewal preserve the options and the price of your plan.'},

      SelectPlanText11: {FR: "Politique d'achat de plan eV Sens", EN: 'EV Sens plan purchase policy'},

      politiqueAchatPlan : {FR: "Dans le cas d'un abonnement facturé annuellement, ceci donne accès aux services du plan choisi pour une durée de 1 ans. Le client bénéficie d'une période d'essaie de 1 mois dans laquelle il peut demander un désabonnement qui sera remboursé au montant de l'achat.  Suite à cette période d'essaie, l'achat du plan ne sera plus remboursable. Si le client désire faire une majoration de son plan de service au cours de la durée de validité de son achat, un crédit sera calculé selon la balance de durée accessible de son plan moins les frais de transaction et d'administration applicable. Si le client active l'option de renouvellement automatique, le plan annuel sera renouveler et facturer automatique à la fin de la précédente période. L'option de renouvellement automatique permet de fixer le prix du plan sans quoi si le client n'active pas le renouvellement automatique avant la fin de la période, le plan de service du client sera remis avec les options du plan de base en date du renouvellement. Le client devra par la suite se ré-abonner selon les plans disponibles en date de ré-inscription. Dans le cas d'une annulation avant échéance, le service sera maintenu jusqu'à expiration de l'engagement. Une fois l'annulation effective le client sera retourné au plan de base gratuit. ",
                      EN: "In the case of a subscription billed annually, this gives access to the services of the plan chosen for a period of 1 year. The customer benefits from a trial period of 1 month in which he can request an unsubscription which will be reimbursed at the amount of the purchase minus the price of the same plan billed monthly. Following this trial period, the purchase of the plan will no longer be refundable. If the customer wishes to make an increase in his service plan during the period of validity of his purchase, a credit will be calculated according to the available duration balance of his plan less the applicable transaction and administration fees. If the customer activates the automatic renewal option, the annual plan will be renewed and billed automatically at the end of the previous period. The automatic renewal option allows you to set the price of the plan, otherwise if the client does not activate the automatic renewal before the end of the period, the client's service plan will be delivered with the options of the basic plan as of renewal. The client must then re-subscribe according to the plans available on the re-registration date. In the case of a cancellation before maturity, the service will be maintained until the expiration of the engagement. Once the cancellation is effective, the customer will be returned to the free basic plan."},

      SelectPlanText12: {FR: "J'accepte les termes et conditions", EN: 'I agree the terms and conditions'},

      validateLocalisation: {FR: 'Validez votre localisation:', EN: 'Validate your location:'},



      ButtonCancelSelection: {FR: "Annuler la sélection", EN: 'Cancel selection'},
      ButtonProceedOrder: {FR: "Procéder à l'achat", EN: 'Proceed to order'},
      ButtonProceedPayment: {FR: "Procéder à l'achat", EN: 'Proceed to payment'},

      InvoiceHeaderFirst: {FR: "Détail de votre premier versement", EN: 'First payment detail'},
      InvoiceHeader: {FR: "Détail de vos versements", EN: 'Payment detail'},
      InvoiceHeaderNext: {FR: "Détail de vos versements par la suite", EN: 'Next payment detail'},
      InvoiceSubscriptionCredit: {FR: "Crédit d'abonnement", EN: 'Subscription credit'},
      InvoiceQuantity: {FR: "Quantité", EN: 'Quantity'},
      InvoiceUnitPrice: {FR: "Prix unitaire", EN: 'Unit price'},
      InvoicePrice: {FR: "Prix", EN: 'Price'},
      InvoiceEVSensServicePlan: {FR: "Plan de service EV Sens", EN: 'EV Sens service plan'},
      InvoiceSubTotal: {FR: "Sous total", EN: 'Sub total'},

      sousTotal1 : 0.00,
      total1:0.00,
      sousTotal2 : 0.00,
      total2: 0.00,
    }
  },

  computed: {
    ...mapState('sessionStore', ['planTransactionData','profileData']),
  },

  methods: {
    ...mapActions('overlayStore', ['showModal']),

    selectPlan(planIndex){
        this.displayYearToggleSelect = false
        this.planTransactionData.planCode = this.planDescription[planIndex]['PlanTemplate']
        this.planTransactionData.planName = this.planDescription[planIndex]['Title'][this.actualLanguage]
        this.planTransactionData.options = this.planDescription[planIndex]['options']
        if (this.monthYearPaymentToggle==true){
            //Annual payment
            this.planTransactionData.yearSinglePaymentFlag = true
            this.planTransactionData.renewalPrice = this.planDescription[planIndex]['PlanPricing'][this.monthYearPaymentToggle]
        }
        else{
            //Monthly payment
            this.planTransactionData.yearSinglePaymentFlag = false
            this.planTransactionData.renewalPrice = this.planDescription[planIndex]['PlanPricing'][this.monthYearPaymentToggle]
        }
        
        //We compute a estimation of the pricing with options for display before confirmation
        this.sousTotal1 = parseFloat(this.planTransactionData.renewalPrice)
        for (var m=0; m<this.planTransactionData.options.length; m++) {
          if (this.planTransactionData.options[m].flagOptionEnabled){
              this.sousTotal1 += parseFloat(this.planTransactionData.options[m].unitPrice)*parseFloat(this.planTransactionData.options[m].quantity)
          }
        }
        this.total1= Math.round((this.sousTotal1)*100)/100     



        //------------------------------------------------
        //------------------------------------------------
        //Conditions de crédit applicable
        //------------------------------------------------

        //Calculer du crédit sur l'exédent de l'abonnement précédent !!!!
        var ActualDate = moment().format('YYYY-MM-DD')
        var ActualTimestamp = Date.parse(ActualDate)/1000
        var renewalDate =this.profileData.profile_subscription.data.renewalDate.slice(0,10)
        var renewalTimestamp = Date.parse(renewalDate)/1000
        var subscriptionBalanceDays = (renewalTimestamp-ActualTimestamp)/86400
        var subscriptionBalancePercent = 0

        if(this.profileData.profile_subscription.data.renewalDelay=="Year"){
              subscriptionBalancePercent = subscriptionBalanceDays/365
        }else{
            subscriptionBalancePercent = subscriptionBalanceDays/30
        }
        var subscriptionBalance = parseInt(subscriptionBalancePercent*this.profileData.profile_subscription.data.renewalPrice - 150)
        var value2 = subscriptionBalance/100
        this.planTransactionData.firstPaymentRebate = '0.0'
        if(subscriptionBalance > 0){
          this.planTransactionData.firstPaymentRebate = value2.toFixed(2)
          }

        var continuePurchaseFlag = true



        //Conditions annulant le crédit ou la transaction
        if(this.profileData.profile_subscription.data.renewalDelay=="Month"){
          if(this.planTransactionData.firstPaymentRebate > this.planTransactionData.renewalPrice+1.5){
            window.alert("Crédit de votre abonnement mensuel précédent n'est pas acessible, si vous pousuivez, vous perdrez vos droits liés à votre abonnement actuel. Il est suggéré d'attendre la fin de votre abonnement actuel avant de diminuer le plan choisi.")
            this.planTransactionData.firstPaymentRebate = '0.0'
            }
          }


        if(this.profileData.profile_subscription.data.renewalDelay=="Year"){
          if((subscriptionBalanceDays < 335) && (this.planTransactionData.firstPaymentRebate > (parseFloat(this.planTransactionData.renewalPrice)+1.5))){
              window.alert("Crédit de votre abonnement annuel précédent n'est pas acessible puisque la période d'essaie de 30 jours est dépassée, si vous pousuivez, vous perdrez vos droits liés à votre abonnement actuel sans remboursement. Il est suggéré d'attendre quelques-temps avant d'effectuer une transaction de réduction de plan.")
              this.planTransactionData.firstPaymentRebate = '0.0'
          }
         
          if((subscriptionBalanceDays >= 335) && (this.planTransactionData.firstPaymentRebate > (parseFloat(this.planTransactionData.renewalPrice)+1.5))){
              window.alert("Communiquez avec eV Sens pour le remboursement de votre abonnement annuel actuel")
              this.planTransactionData.firstPaymentRebate = '0.0'
          }
          //continuePurchaseFlag = false
        }
        //------------------------------------------------
        //------------------------------------------------


        //Liste des états:
        //this.planTransactionData.transactionStatusCode
        //'000' : Etat de base
        //'050' : Affichage du choix des plans
        //'060' : Affichage du plan choisi, pret pour achat
        //'100' : Afficher le detail de la facture, pret pour paiement
        //'999' : Transaction terminée, 
        if (continuePurchaseFlag){
          this.planTransactionData.postAction = 'NewSubscription'
          this.planTransactionData.transactionStatusCode = '060'
          this.displaySelectedPlanFlag = true
          this.acceptConditionFlag = false
          window.scrollTo(0, 0)
        }
    },



    cancelSelection(){
      this.displayYearToggleSelect = true
      this.displaySelectedPlanFlag = false
      this.planTransactionData.transactionStatusCode = '050'
      window.scrollTo(0, 0)

    },

    confirmOrder(){

      this.sousTotal1 = Math.round((parseFloat(this.planTransactionData.renewalPrice) - parseFloat(this.planTransactionData.firstPaymentRebate))*100)/100

      for (var m=0; m<this.planTransactionData.options.length; m++) {
        if (this.planTransactionData.options[m].flagOptionEnabled){
            this.sousTotal1 += parseFloat(this.planTransactionData.options[m].unitPrice)*parseFloat(this.planTransactionData.options[m].quantity)
        }
      }
      

      var SumTax = 0
      var SumSubTotal = this.sousTotal1
      for (var n = 0; n < this.actualTaxes01.length; n++) {
        this.actualTaxes01[n].Amount = (Math.round(SumSubTotal*parseFloat(this.actualTaxes01[n].Rate)*100)/100).toString()

        if (this.actualTaxes01[n].CumulativeSubtotal){SumSubTotal += parseFloat(this.actualTaxes01[n].Amount)}
        SumTax += parseFloat(this.actualTaxes01[n].Amount)
      }
      this.total1= Math.round((this.sousTotal1 + SumTax)*100)/100


      this.sousTotal2 = Math.round(parseFloat(this.planTransactionData.renewalPrice)*100)/100
      SumTax = 0
      SumSubTotal = this.sousTotal2
      for (var n = 0; n < this.actualTaxes01.length; n++) {
        this.actualTaxes02[n].Amount = (Math.round(SumSubTotal*parseFloat(this.actualTaxes02[n].Rate)*100)/100).toString()

        if (this.actualTaxes02[n].CumulativeSubtotal){SumSubTotal += parseFloat(this.actualTaxes02[n].Amount)}
        SumTax += parseFloat(this.actualTaxes02[n].Amount)
      }
      this.total2= Math.round((this.sousTotal2 + SumTax)*100)/100

      this.planTransactionData.transactionStatusCode = '100'
      window.scrollTo(0, 0)

    },





    getUserPlanList(){
      var requestData = { 'postAction':'GetUserPlanList',
                          'subscriptionListId': process.env.VAR_PLAN_USER_LIST,
                          }
      //console.log(requestData)
      this.$store.dispatch('sessionStore/processSubscription', requestData)
        .then((response) => {
          //console.log(response)
          if(response.data.Code=='OK'){
            //console.log('--PLAN LIST---')
            //console.log(response.data)
            this.planDescription = response.data.PlanList
            this.flagShowPlanList = true
            }
        })
    },

    getCountryStateTaxList(){
      var requestData = { 'postAction':'GetCountryTaxRates',
                          }
      //console.log(requestData)
      this.$store.dispatch('sessionStore/processSubscription', requestData)
        .then((response) => {
          //console.log(response.data)
          if(response.data.Code=='OK'){
            //CountryList = [{'Country':'','StateTaxData':[]}]
            this.countryStateTaxRates = response.data.CountryList
            
            //Application by default the Canada:Quebec Tax rate
            for (var n = 0; n < this.countryStateTaxRates.length; n++) {
              if(this.countryStateTaxRates[n].Country == 'Canada'){
                for(var m = 0; m < this.countryStateTaxRates[n].StateTaxData.StateList.length; m++){
                  if(this.countryStateTaxRates[n].StateTaxData.StateList[m].Name.EN=='Quebec'){
                    this.actualCountryName = this.countryStateTaxRates[n].Country
                    this.actualStateNames = this.countryStateTaxRates[n].StateTaxData.StateList[m].Name
                    this.actualTaxes01 = structuredClone(this.countryStateTaxRates[n].StateTaxData.StateList[m].Taxes)
                    this.actualTaxes02 = structuredClone(this.countryStateTaxRates[n].StateTaxData.StateList[m].Taxes)
                  }
                }
              }
            }

            }
        })
    },

    selectActualCountry(){
      this.actualStateIndex = -1
      this.planTransactionData.taxRateData = {'countrySortKey':'Canada',
                                        'stateNames':{FR:'Québec',EN:'Quebec'}}
    },

    selectActualState(){
      if(this.actualCountryIndex >= 0 & this.actualStateIndex>=0){
        this.actualCountryName = this.countryStateTaxRates[this.actualCountryIndex].Country
        this.actualStateNames = this.countryStateTaxRates[this.actualCountryIndex].StateTaxData.StateList[this.actualStateIndex].Name
        this.actualTaxes01 = structuredClone(this.countryStateTaxRates[this.actualCountryIndex].StateTaxData.StateList[this.actualStateIndex].Taxes)
        this.actualTaxes02 = structuredClone(this.countryStateTaxRates[this.actualCountryIndex].StateTaxData.StateList[this.actualStateIndex].Taxes)

        this.planTransactionData.taxRateData = {'countrySortKey':this.actualCountryName,
                                                'stateNames':this.actualStateNames}
      
      //console.log(this.planTransactionData)
      }
    },

  },




  mounted() {
    //Retirer l'inversion puisque le composant PortGraph effectue l'inversion sur la variable 
    //this.tableData = this.portData.reverse();
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
    this.planTransactionData.taxRateData = {'countrySortKey':'Canada',
                                      'stateNames':{FR:'Québec',EN:'Quebec'}}

    this.getUserPlanList()
    this.getCountryStateTaxList()

  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// UserPlanTable.vue?e4438acc